import { render, staticRenderFns } from "./onboard.vue?vue&type=template&id=36b8785f"
import script from "./onboard.vue?vue&type=script&lang=js"
export * from "./onboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports